import { Component, ElementRef, HostListener, OnInit, OnDestroy, ViewChild, Inject, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IdexService } from 'app/idex.service';
import { GoogleDriveListComponent } from '../google-drive-list/google-drive-list.component';
import { TranslateService } from '@ngx-translate/core';
import { Path } from 'app/shared/path';
import { Subscription, Subject } from 'rxjs';
import { Toast } from 'app/shared/toast/toast';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { CreateGoogleDriveComponent } from '../google-drive/create-google-drive.component';
import { UploadProgressComponent } from '../upload-progress/upload-progress.component';
import { GoogleUploaderService } from '../google-uploader.service';
import { Location } from '@angular/common';
import { SocialLogin } from 'app/account/social-login';

declare const google: string;

@Component({
   selector: 'app-google-drive-page',
   templateUrl: './google-drive-page.component.html',
   styleUrls: ['./google-drive-page.component.css']
})
export class GoogleDrivePageComponent implements OnInit, OnDestroy {

   @ViewChild(GoogleDriveListComponent, { static: true }) GoogleDriveList: GoogleDriveListComponent;
   @ViewChild('progress') progress: UploadProgressComponent;
   isBusiness: boolean;
   private path: string;
   private drivePath: string;
   private pageToken: string;
   private size = 50;
   hasMore = false;
   public canDrag = true;
   paths: any[];
   drivePaths: any[] = [];
   event_param:{
      event_page: any,
      event_label: any,
      event_action: any
   }

   resultSubscription: Subject<any> = new Subject<any>();

   pathFolder: string;
   uploadFileSize: number = 0;
   uploadResultFileSize: number = 0;

   doc: any;
   selectedItems: any[] = [];

   success: any;
   content: any;
   doc_id: any;

   position = 'below';
   private subscriber: Subscription;

   @ViewChild('toolbar') toolbar: ElementRef;
   limit: any;
   access_token: any;
   supportFolderUpload: boolean;

   private uploadCallback = {
      init: (files) => {
         this.progress.init(files);
      },
      initFolder: (folder, name:string) => {
         this.progress.initFolder(folder, name);
      },
      progress: (i: number, progress: number) => {
         this.progress.update(i, progress);
      },
      cancelUpload: (i: number, error: string) => {
         this.progress.cancelUpload(i, error);
      },
      complete: () => {
         const result = this.progress.complete();

         setTimeout(() => {
            this.progress.hide();
            this.showDocument();
         }, this.progress.calcDelay());
      }
   };

   constructor(
      @Inject(MAT_DIALOG_DATA) private data: any,
      private router: Router,
      private route: ActivatedRoute,
      protected service: IdexService,
      private translate: TranslateService,
      private dialog: MatDialog,
      private toast: Toast,
      public googleService: GoogleUploaderService,
      private renderer: Renderer2,
      private location: Location,
      private socialLogin:SocialLogin
   ) {}

   ngOnInit(): void {
      this.route.queryParams.subscribe(params => {
         if (params['fileId']) {
            this.drivePath = JSON.parse(params['fileId']);
            this.pathFolder = this.drivePath;
         } else {
            this.drivePath = 'root';
            this.pathFolder = 'root';
         }
      });
      this.subscriber = this.route.url.subscribe(url => {
         this.path = decodeURIComponent(url.join('/'));
         if (this.path.length !== 0 && history.state.drivePaths) {
            this.drivePaths = history.state.drivePaths;
            const array = this.path.match(/[^/]+/g);
            this.drivePaths = this.drivePaths.slice(0, array.length);
         } else {
            this.drivePaths = [];
            this.path = '';
            this.location.replaceState('/googleDrivePage');
         }
         this.createBreadcrumb();
         if (sessionStorage.getItem('access_token_google')) {
            this.access_token = sessionStorage.getItem('access_token_google');
            this.showDocument();
            this.GoogleDriveList.items = undefined;
            this.GoogleDriveList.access_token = this.access_token;
         }
      });

      const input = document.createElement('input');
      this.supportFolderUpload = ('webkitdirectory' in input
         || 'mozdirectory' in input
         || 'odirectory' in input
         || 'msdirectory' in input
         || 'directory' in input);
   }

   ngOnDestroy(): void {
      this.subscriber.unsubscribe();
   }

   @HostListener('window:scroll')
   scrollFixed() {
      this.toolbar.nativeElement.style.left = (240 - window.scrollX) + 'px';
   }

   private createBreadcrumb(): void {
      this.translate.get('main.google-drive').subscribe(files => {
         if (this.path.length === 0) {
            this.paths = [{ name: files }];
            this.GoogleDriveList.paths = this.paths;
            return;
         }
         const paths = [];
         paths.push({ name: files });

         let fullPath = '';
         const array = this.path.match(/[^/]+/g);
         for (let i = 0; i < array.length; i++) {
            if (i === array.length - 1) {
               fullPath = null;
            } else {
               if (fullPath.length > 0) {
                  fullPath += '/';
               }
               fullPath += array[i];
            }
            paths.push({ name: array[i], path: fullPath });
         }
         this.paths = paths;
         this.GoogleDriveList.paths = this.paths;
      });
   }

   showDocument() {
      this.selectedItems = [];
      const path = location.pathname;
      this.service.getGoogleDriveList(this.drivePath, this.access_token, this.size, null)
         .subscribe(res => {
            const data = JSON.parse(res);
            this.setFileParent(data);
            this.hasMore = data.nextPageToken ? true : false;
            this.GoogleDriveList.setItems(data.files, this.hasMore);
            this.pageToken = data.nextPageToken;
         }, error => {
            if (error.code === 401 || error.status === 401) {
               this.socialLogin.withGoogle().subscribe(result => {
                  this.access_token = sessionStorage.getItem("access_token_google")
                  this.showDocument();
               }, error => {
                  this.data.toast.error(error);
                  const pathUrl = Path.combine('/login', path);
                  this.router.navigate([pathUrl]);
               });
            }
         });
   }

   onLoadMore() {
      this.service.getGoogleDriveList(this.drivePath, this.access_token, this.size, this.pageToken)
      .subscribe(res => {
         const data = JSON.parse(res);
         this.setFileParent(data);
         this.hasMore = data.nextPageToken ? true : false;
         this.GoogleDriveList.addItems(data.files, this.hasMore);
         this.pageToken = data.nextPageToken;
      });
   }

   onClickItem(item: any) {
      let path = location.pathname;
      const idex = '/idex';
      if (path.startsWith(idex)) {
         path = path.substring(idex.length);
      }

      localStorage.setItem('url', Path.combine(path));
      if (item.mimeType === 'application/vnd.google-apps.folder') {
         const url = Path.combine('/googleDrivePage', encodeURIComponent(this.path), encodeURIComponent(item.name));
         this.drivePaths.push(encodeURIComponent(item.id));

         this.router.navigate([url], { state: { drivePaths: this.drivePaths }, queryParams: { 'fileId': JSON.stringify(item.id) } });
      } else if (item.mimeType === 'text/xml' && item.name.toLowerCase().endsWith('.zdox')) { 
         this.service.getEFormByXml('googledrive', { access_token: this.access_token, fid: item.id, name: item.name}).subscribe((res) => {
            let url = location.origin + this.router.createUrlTree(['/eform/create/view/file']);
            if (res?.data) {
               let form = res.data;
               localStorage.setItem('form-type', 'view');
               localStorage.setItem('filename', item.name);
               localStorage.setItem('form-view', JSON.stringify(form));
               localStorage.setItem('isOpenFile', "true");
               window.open(url, '_blank');
            }
         });
      } else {
         window.open(item.webViewLink);
      }
   }

   loadDocuments() {
      this.selectedItems = [];

      this.service.getGoogleDriveList(this.drivePath, this.access_token, this.size, this.pageToken)
         .subscribe(res => {
            const data = JSON.parse(res);
            this.setFileParent(data);
            this.hasMore = data.nextPageToken ? true : false;
            this.GoogleDriveList.setItems(data.files, this.hasMore);
            this.pageToken = data.nextPageToken;
         });
   }

   navigate(path) {
      this.doc = undefined;
      if (path.path) {
         const url = Path.combine('/googleDrivePage', encodeURIComponent(path.path));
         this.router.navigate([url], {
            state: { drivePaths: this.drivePaths },
            queryParams: { 'fileId': JSON.stringify(this.drivePaths[path.path.split('/').length - 1]) }
         });
      } else {
         this.router.navigate(['/googleDrivePage']);
      }
   }

   newFolder(createType: string) {
      const dialogRefGoogle = this.dialog.open(CreateGoogleDriveComponent, {
         disableClose: true,
         data: {
            pathFolder: this.pathFolder,
            type: 'document',
            createType: createType,
            component: GoogleDrivePageComponent.name,
         }
      });
      this.dialog.afterAllClosed.subscribe(() => {
         this.GoogleDriveList.toggleLoading();
         setTimeout(() => {
            this.showDocument();
         },2000);
      });
   }

   startGoogle(type: any) {
      this.canDrag = false;
      const google = this.dialog.open(CreateGoogleDriveComponent, {
         disableClose: true,
         data: {
            path: this.path,
            type: type,
            createType: type,
            pathFolder: this.pathFolder,
            component: GoogleDrivePageComponent.name,
         }
      });
      google.componentInstance.isBusiness = false;
      this.dialog.afterAllClosed.subscribe(() => {
         this.canDrag = true;
         this.showDocument();
      });
   }

   uploadFile(files) {
      let tempFiles = [];
      for (const file of files) {
         file.uploadFolderId = this.pathFolder;
         tempFiles.push(file);
      }
      this.googleService.uploadFiles(this.access_token, tempFiles, this.uploadCallback );
   }

   uploadFolder(files) {
      try{
         let tempFiles = [];
         for (const file of files) {
            file.uploadFolderId = this.pathFolder;
            tempFiles.push(file);
         }
         this.googleService.uploadFolder(this.access_token, files, this.uploadCallback, this.pathFolder);
      }catch(e){
         this.toast.error(e);
      }
   }

   getOldFileList(): string[]{
      return this.GoogleDriveList.items.filter(item => item.mimeType != 'application/vnd.google-apps.folder');
   }

   onDragOver(event: DragEvent) {
      const data = event.dataTransfer;
      let hasFiles = false;
      if (data.items) {
         for (let i = 0; i < data.items.length; i++) {
            if (data.items[i].kind === 'file') {
               hasFiles = true;
               break;
            }
         }
      } else if (data.files && data.files.length > 0) {
         hasFiles = data.files && data.files.length > 0;
      }
      if (hasFiles && !this.googleService.busy) {
         event.preventDefault();
         event.stopPropagation();
         event.dataTransfer.dropEffect = 'copy';
         this.renderer.addClass(this.GoogleDriveList.nativeElement, 'drag-over');
      }
   }

   onDrop(e: DragEvent) {
      e.preventDefault();
      e.stopPropagation();
      this.renderer.removeClass(this.GoogleDriveList.nativeElement, 'drag-over');

      this.event_param = {
         event_page: "google",
         event_label: "drop",
         event_action: "upload"
      }
      this.googleService.process(this.access_token, e.dataTransfer, this.uploadCallback, this.pathFolder, this.getOldFileList());
   }

   onDragLeave() {
      this.renderer.removeClass(this.GoogleDriveList.nativeElement, 'drag-over');
   }

   setFileParent(data){
      data.files.forEach(item => {
         item.parent = this.drivePath;
      });
   }
}
